import { faMoon, faSunBright } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@sixui/ui';
import { useTernaryDarkMode } from 'usehooks-ts';

import type { IContainerProps } from '~/components/utils/Container';

export type IColorSchemeSwitchProps = IContainerProps;

export const ColorSchemeSwitch: React.FC<IColorSchemeSwitchProps> = (props) => {
  const { sx } = props;
  const { isDarkMode, setTernaryDarkMode } = useTernaryDarkMode();

  return (
    <IconButton
      sx={sx}
      variant="outlined"
      icon={<FontAwesomeIcon icon={faMoon} />}
      selectedIcon={<FontAwesomeIcon icon={faSunBright} />}
      selected={isDarkMode}
      onClick={() => setTernaryDarkMode(isDarkMode ? 'light' : 'dark')}
    />
  );
};
